import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Haley Halcyon
 * id 9201098E-A360-4BF2-8EC7-683EB2AA7FEF
 * name syllabary-hangul
 * version: 4.9.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/syllabary-hangul.svg
 * tags
 * - Alpha / Numeric 
 */
export const SyllabaryHangulIcon = createSvgIcon(<><path d="M8 4V6H4V8H6.39C5.55 8.74 5 9.8 5 11C5 13.2 6.8 15 9 15C11.2 15 13 13.2 13 11C13 9.8 12.45 8.74 11.61 8H14V6H10V4M15 4V16H17V11H20V9H17V4M9 9C10.12 9 11 9.88 11 11C11 12.12 10.12 13 9 13C7.88 13 7 12.12 7 11C7 9.88 7.88 9 9 9M7 16V20H17V18H9V16Z" /></>, 'SyllabaryHangulIcon');
export default SyllabaryHangulIcon